import { ColorFacetComponentConfig, HawkSearchComponents } from '@configuration';
import { ColorFacetComponentModel, ColorFacetValue } from '@models';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './color-facet.component.hbs';

/**
 * The Color Facet component renders a box with color preview for each value.
 *
 * ## Tag
 * The tag for this component is `<hawksearch-color-facet>`.
 *
 * ## Event-Binding Attributes
 * *Note: For Event-Binding attributes common to all facet type components, see {@link Components.BaseFacetComponent}.*
 *
 * ## Default Template
 * The following is the default Handlebars template for this component. To create a custom template, it is recommended to use this as a starting point.
 * {@embed ./color-facet.component.hbs}
 *
 * @category Facet Types
 */
export class ColorFacetComponent extends BaseFacetComponent<ColorFacetComponentConfig, ColorFacetComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'color-facet';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data;
    }

    protected override getContentModel(): ColorFacetComponentModel {
        const filterRegex = this.state.filter ? new RegExp(this.state.filter, 'i') : undefined;

        return {
            values:
                this.data!.values?.filter((c) => c.color).map(
                    (v, i): ColorFacetValue => ({
                        ...v,
                        visible:
                            (!filterRegex && (this.state.toggled || !this.data!.truncation || i < this.data!.truncation.threshold)) ||
                            (!!filterRegex && filterRegex.test(v.title ?? ''))
                    })
                ) ?? [],
            showToggle: !!this.data!.truncation && (this.data!.values?.length ?? 0) > this.data!.truncation.threshold && !this.state.filter,
            expanded: this.state.toggled ?? false,
            excludeEnabled: this.configuration?.excludeEnabled ?? false,
            strings: {
                exclude: this.configuration?.strings?.exclude ?? 'Exclude',
                include: this.configuration?.strings?.include ?? 'Include',
                toggle: this.state.toggled ? this.configuration?.strings?.showFewer ?? 'Show fewer' : this.configuration?.strings?.showMore ?? 'Show more'
            }
        };
    }
}
